import {
    WidgetReceiveRpcStreamResponseAction,
    createReceiveRpcResponseAction,
    WidgetReceiveRpcStreamResponseActionPayload,
} from 'widgets/store/rpcStream/actions';
import {
    createClearStreamDataAction,
    WidgetClearStreamDataAction,
} from 'widgets/store/stream/actions';
import { WidgetTypeActionPayload } from 'widgets/store/actions';
import { ExpertiseResponse } from 'communication/types/expertise/ExpertiseResponse';
import { ExpertiseWidgetType } from 'widgets/expertise/ExpertiseWidgetStrategy';

export type ExpertiseMessageReceive =
    WidgetReceiveRpcStreamResponseAction<ExpertiseResponse>;

export const createExpertiseResponseAction = (
    widgetType: ExpertiseWidgetType
) => createReceiveRpcResponseAction<ExpertiseResponse>(widgetType);

export const clearExpertiseDataAction = (widgetType: ExpertiseWidgetType) =>
    createClearStreamDataAction(widgetType);

export type ExpertiseStreamActionPayload =
    | WidgetTypeActionPayload
    | WidgetReceiveRpcStreamResponseActionPayload<ExpertiseResponse>;

export type ExpertiseStreamAction =
    | WidgetClearStreamDataAction
    | ExpertiseMessageReceive;
